/* eslint-disable @typescript-eslint/naming-convention */
import i18n from "i18next"; // eslint-disable-line import/no-named-as-default
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const baseConfig = {
  interpolation: {
    escapeValue: false,
  },
  react: { useSuspense: false },
  ns: ["common", "dashboard", "donationForm", "ticketing", "ticketScan", "campaignHub"],
  backend: {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
  },
};

const isBuild =
  process.env.NEXT_PHASE === "phase-production-build" ||
  (process.env.NODE_ENV === "production" && typeof window === "undefined");

/**
 * Minimal, synchronous init used only during build/SSR bootstrap.
 * No backend, no network, just enough so i18n.language is defined and
 * <I18nextProvider> doesn’t crash.
 */
if (isBuild) {
  // eslint-disable-next-line import/no-named-as-default-member
  i18n.use(initReactI18next).init({
    initImmediate: false, // sync init
    lng: "en",
    fallbackLng: false,
    resources: {}, // no dictionaries
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

if (!i18n.isInitialized && !isBuild) {
  i18n // eslint-disable-line import/no-named-as-default-member
    .use(Backend)
    .use(initReactI18next)
    .init({
      ...baseConfig,
      partialBundledLanguages: true,
      load: "currentOnly",
      nonExplicitSupportedLngs: false,
      fallbackLng: {
        "fr-CA": ["fr"],
        "en-CA": ["en"],
        "en-US": ["en"],
        "en-GB": ["en"],
        "es-US": ["es"],
      },
      debug: process.env.NODE_ENV === "development",
      supportedLngs: ["en", "en-US", "en-CA", "en-GB", "fr", "fr-CA", "es", "es-US"],
    });
}

export default i18n;
